/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type CoaExpensesDtoCategory =
  (typeof CoaExpensesDtoCategory)[keyof typeof CoaExpensesDtoCategory];

export const CoaExpensesDtoCategory = {
  FOOD: 'FOOD',
  HOUSING: 'HOUSING',
  OTHER_EXPENSES: 'OTHER_EXPENSES',
  REQUIRED_FEES: 'REQUIRED_FEES',
  TUITION: 'TUITION',
} as const;
